export const THEME_COLOR = {
  Primary: "#23260E",
  Secondary: "#818C2E",
  Tertiary: "#515914",
  Important: "#A62F24",
  Light: "#F2C1AE",
  White: "#FFFFFF",
  Black: "#000000"
}